import { useMutation, useQueryClient } from 'react-query';
import { ITcoLocations } from 'types';
import { tcoLocationRequest, queryKeys } from 'utils';

export const usePostTcoLocations = (estimateId: string) => {
  const queryClient = useQueryClient();
  const queryKey = queryKeys({ estimateId }).filter.tcoLocations;

  const {
    mutate: postTcoLocation,
    isLoading: postTcoLocationLoading,
    isSuccess: postTcoLocationSuccess,
    isError: postTcoLocationError,
  } = useMutation(
    (tcoLocation: Partial<ITcoLocations>) => {
      const processedLocation = {
        ...tcoLocation,
        underlaySelections: tcoLocation.underlaySelections?.map(
          (selection: any) => {
            if (selection.id.startsWith('new-') || !selection.id) {
              const { id, locationId, ...selectionWithoutIds } = selection;
              return selectionWithoutIds;
            }
            return selection;
          }
        ),
      };

      return tcoLocationRequest({
        method: 'POST',
        data: [processedLocation],
      });
    },
    {
      onMutate: async (newTcoLocation: Partial<ITcoLocations>) => {
        await queryClient.cancelQueries(queryKey);

        const previousLocations =
          queryClient.getQueryData<ITcoLocations[]>(queryKey) || [];

        return { previousLocations };
      },
      onError: async (err, _, context) => {
        console.log(err);
        await queryClient.cancelQueries(queryKey);
        queryClient.setQueryData(queryKey, context?.previousLocations);
      },
      onSettled: () => {
        queryClient.invalidateQueries(queryKey);
      },
    }
  );

  return {
    postTcoLocation,
    postTcoLocationLoading,
    postTcoLocationSuccess,
    postTcoLocationError,
  };
};
